"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tbackground: rgba(0, 0, 0, 0.5);\n\tz-index: 100;\n\tpadding: 4em;\n\tcursor: pointer;\n"], ["\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tbackground: rgba(0, 0, 0, 0.5);\n\tz-index: 100;\n\tpadding: 4em;\n\tcursor: pointer;\n"]),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n\tbackground: white;\n\tmargin: 0 auto;\n\twidth: 100%;\n\tmax-width: 800px;\n\tcursor: auto;\n\tpadding: 2.5em;\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& > ", " {\n\t\tflex-shrink: 0;\n\t}\n"], ["\n\tbackground: white;\n\tmargin: 0 auto;\n\twidth: 100%;\n\tmax-width: 800px;\n\tcursor: auto;\n\tpadding: 2.5em;\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& > ", " {\n\t\tflex-shrink: 0;\n\t}\n"]),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(["\n\tfont-size: 1.6em;\n\tflex-shrink: 0;\n"], ["\n\tfont-size: 1.6em;\n\tflex-shrink: 0;\n"]),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(["\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\tmargin: 1.5em 0;\n\toverflow-y: auto;\n"], ["\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\tmargin: 1.5em 0;\n\toverflow-y: auto;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _recompose = require("recompose");

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _button = require("./button");

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Overlay = _styledComponents2.default.div(_templateObject);

var Box = _styledComponents2.default.div(_templateObject2, _button2.default.Container);

var Title = _styledComponents2.default.div(_templateObject3);

var Content = _styledComponents2.default.div(_templateObject4);

var enhance = (0, _recompose.compose)();

var stopPropagation = function stopPropagation(e) {
	return e.stopPropagation();
};

var Modal = function Modal(props) {
	return props.visible ? _react2.default.createElement(
		Overlay,
		{ onClick: props.close },
		_react2.default.createElement(
			Box,
			{ onClick: stopPropagation },
			_react2.default.createElement(
				Title,
				null,
				props.title || "<Modal title goes here>"
			),
			_react2.default.createElement(
				Content,
				null,
				props.children
			),
			_react2.default.createElement(
				_button2.default.Container,
				{ alignRight: true },
				props.options ? props.options.map(function (_ref, i) {
					var label = _ref.label,
					    fn = _ref.fn,
					    type = _ref.type;
					return _react2.default.createElement(_button2.default, {
						type: type || "CONFIRM",
						onClick: fn,
						text: label,
						key: i
					});
				}) : _react2.default.createElement(_button2.default, {
					type: "CONFIRM",
					onClick: props.close,
					text: "Close"
				})
			)
		)
	) : null;
};

exports.default = enhance(Modal);

//# sourceMappingURL=modal.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/modal.js
// module id = 375
// module chunks = 0